


const Phone = ({ enCode, attributes, clickOpenTelTo, reverseString }) => {
    const { content } = attributes;
    const revPNumber = reverseString(content?.phone);
    return <a href={`${enCode}`} target='__blank' onClick={() => { event.preventDefault(); clickOpenTelTo(content); }}>{revPNumber}<div id='innerContainer'></div></a>
}
export default Phone;